import { AuthLoginCtrlApi, AuthManagementCtrlApi } from "./generated/api";
import { apiCall, axiosInstance, config, getConfig, serverUrl } from "./Utils";
import { APP_NAME } from "../App";
import type { ApiResult, PromiseOpenId, PromiseUser, PromiseUserShort, UpdateProfileDto, UserDto } from "../types/api";

const authLogin = new AuthLoginCtrlApi(config, serverUrl, axiosInstance);
const authManagement = new AuthManagementCtrlApi(config, serverUrl, axiosInstance);

/**
 * Authentification (login ou refresh token).
 * Les headers CORS côté client sont des headers de réponse serveur — supprimés.
 */
async function login(
    grant_type: string,
    loginName?: string,
    password?: string,
    refreshToken?: string,
    accessToken?: string
): Promise<ApiResult<PromiseOpenId>> {
    const option = {
        headers: {
            "Content-Type": "application/x-www-form-urlencoded",
            Accept: "application/json",
        },
    };
    return apiCall(
        authLogin.apiAuthInstanceLoginPost(
            APP_NAME,
            grant_type,
            loginName,
            password,
            refreshToken,
            accessToken,
            option
        )
    );
}

/**
 * Crée un nouveau compte utilisateur (inscription publique).
 * Endpoint : POST /api/auth/management/create
 * Utilise UserDto (userName, nom, prenom, email, institution, password).
 */
async function createUser(user: UserDto): Promise<ApiResult<void>> {
    return apiCall(authManagement.apiAuthManagementCreatePost(user, getConfig()));
}

async function resetUser(email: string): Promise<ApiResult<void>> {
    return apiCall(
        axiosInstance.get(`${serverUrl}/api/auth/management/reset`, { params: { email } })
    );
}

async function listUsers(): Promise<ApiResult<PromiseUserShort[]>> {
    return apiCall(authLogin.apiAuthInstanceUsersGet(APP_NAME, getConfig()));
}

async function userInfo(): Promise<ApiResult<PromiseUser>> {
    return apiCall(authLogin.apiAuthInstanceMeGet(APP_NAME, getConfig()));
}

async function updateUserProfile(
    login: string,
    firstName: string,
    lastName: string,
    email: string,
    institution: string
): Promise<ApiResult<void>> {
    const dto: UpdateProfileDto = { login, firstName, lastName, email, institution };
    return apiCall(
        authManagement.apiAuthManagementUpdateProfilePut(dto, getConfig())
    );
}

async function updatePassword(
    login: string,
    oldPassword: string,
    newPassword: string
): Promise<ApiResult<void>> {
    return apiCall(
        authManagement.apiAuthManagementUpdatePasswordPost({ login, oldPassword, newPassword }, getConfig())
    );
}

const ApiAuthCtrl = {
    login,
    createUser,
    resetUser,
    listUsers,
    userInfo,
    updateUserProfile,
    updatePassword,
};

export default ApiAuthCtrl;
